import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const path = window.location.pathname;
// TOTO iframe 不能吃 firebase
let skipFirebase = path.includes("/sso-upgpt-login") || path.includes("/upgpt") || path.includes("/upgpt_portal");
console.log(`Location Path: ${path}`);

let messaging = null;
if (!skipFirebase) {
    console.log('Firebase not skipped');
    // Import the functions you need from the SDKs you need
    var firebaseConfig = {
        apiKey: "AIzaSyBW-86BI4yXSLdJBgeQ42K0vW9VLDtNRR4",
        authDomain: "cm2-crmapp-prod.firebaseapp.com",
        projectId: "cm2-crmapp-prod",
        storageBucket: "cm2-crmapp-prod.appspot.com",
        messagingSenderId: "32944569494",
        appId: "1:32944569494:web:4ebd73455b2409571996b7",
        measurementId: "G-7P1THQT4VT"
    };

    try {
        const app = initializeApp(firebaseConfig);
        messaging = getMessaging(app);
    } catch (e) {
        console.warn('Firebase Messaging init failed (HTTP or unsupported browser):', e.message);
    }
} else {
    console.log('Skip firebase');
}

export default messaging;
